<div class="border-1 bg-white p-2 border-round-lg border-gray-400">
  <p class="text-lg my-1">How do you plan to travel to the first pick-up location?</p>
  <p class="text-gray-700">{{ address }}</p>

  <div class="grid mx-1">
    <div *ngFor="let mode of availableTransportModes" class="col-3">
      <div class="mx-1 h-full w-full relative">
        <div
          style="width: 16px; height: 16px; top: 16px; left: 16px; padding: 3px"
          class="flex justify-content-center align-items-center border-round-xl absolute bg-white {{
            mode == selectedTransportMode
              ? ' border-2  border-blue-400'
              : ' border-1 border-gray-400'
          }}"
        >
          <div
            *ngIf="mode == selectedTransportMode"
            class="bg-blue-500 w-full h-full border-circle"
          ></div>
        </div>
        <div
          (click)="selectTransportMode(mode)"
          class="h-full flex flex-column justify-content-center align-items-center
          hover:bg-gray-100 border-round-lg px-4 py-2 cursor-pointer
          text-center {{
            mode == selectedTransportMode
              ? 'bg-blue-50 border-blue-400 border-2'
              : 'bg-white border-gray-400 border-1'
          }}"
        >
          <transport-icon-switch [mode]="mode"></transport-icon-switch>
          <span class="mt-2">{{ getTransportModeText(mode) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
